// extracted by mini-css-extract-plugin
export default {"report":"OrderPayments_report__LdDly","report-header":"OrderPayments_report-header__35UyI"};